import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router';
import { paths } from 'src/routes/paths';
import { useCouponsStore } from 'src/store/benefits/coupons.store';
import * as Yup from 'yup';

export default function useRefuseDialog() {
  const { id } = useParams();

  const navigate = useNavigate();

  const { refuseLPCoupon } = useCouponsStore();

  const defaultValues = {
    declineComment: '',
  };

  const refuseSchema = Yup.object().shape({
    declineComment: Yup.string().required('Comentário é obrigatório'),
  });

  const methods = useForm({
    resolver: yupResolver(refuseSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      if (id) {
        refuseLPCoupon(id, data.declineComment);
        navigate(paths.dashboard.lpCouponsList);
      }
    } catch (error) {
      console.error(error);
    }
  });

  return {
    handleSubmit,
    reset,
    onSubmit,
    methods,
    isSubmitting,
    id,
  };
}
